import { render, staticRenderFns } from "./loadSkeleton.vue?vue&type=template&id=6921e480&scoped=true"
import script from "./loadSkeleton.vue?vue&type=script&lang=js"
export * from "./loadSkeleton.vue?vue&type=script&lang=js"
import style0 from "./loadSkeleton.vue?vue&type=style&index=0&id=6921e480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6921e480",
  null
  
)

export default component.exports